// src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import ar from './locales/ar.json';

// Languages that should render right-to-left. Kept tiny so it can be
// reused by any UI that toggles the document direction.
export const RTL_LANGS = new Set(['ar']);

export const isRtl = (lng) => RTL_LANGS.has((lng || '').split('-')[0]);

const applyDirection = (lng) => {
  if (typeof document === 'undefined') return;
  const code = (lng || 'en').split('-')[0];
  document.documentElement.lang = code;
  document.documentElement.dir = isRtl(code) ? 'rtl' : 'ltr';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      ar: { translation: ar },
    },
    supportedLngs: ['en', 'fr', 'es', 'ar'],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    returnObjects: false,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'wesafar-lang',
    },
  })
  .then(() => applyDirection(i18n.language));

// Keep <html dir>/<html lang> in sync with the active i18n language.
i18n.on('languageChanged', applyDirection);

export default i18n;

